import { Button, Stack, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ReactNode } from "react";

interface FormHeaderProps {
  backLabel?: ReactNode;
  onBack?: () => void;
  eyebrow?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  textAlign?: "center" | "left";
}

export const FormHeader = ({
  backLabel,
  onBack,
  eyebrow,
  title,
  description,
  textAlign = "left",
}: FormHeaderProps) => {
  return (
    <Stack spacing={4} sx={{ marginBottom: 4 }}>
      {backLabel && onBack && (
        <Button
          type="button"
          variant="text"
          color="inherit"
          size="xsmall"
          onClick={onBack}
          startIcon={<ArrowBackIcon />}
          sx={{ alignSelf: "flex-start", color: "text.secondary" }}
        >
          {backLabel}
        </Button>
      )}
      {eyebrow && (
        <Typography variant="h6" color="text.secondary">
          {eyebrow}
        </Typography>
      )}
      <Stack spacing={2} sx={{ alignItems: textAlign }}>
        <Typography variant="h1" color="primary.dark">
          {title}
        </Typography>
        {description && (
          <Typography
            component="p"
            variant="bodyLgRegular"
            color="text.primary"
          >
            {description}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};
